import clsx from 'clsx'
import { CSSProperties, ReactNode } from 'react'

import cl from './FullWidthContainer.module.scss'

type FullWidthContainerProps = {
	className?: string
	style?: CSSProperties
	children: ReactNode
	variant?: 'section' | 'slider' | 'subsection'
}

export const FullWidthContainer = (props: FullWidthContainerProps) => {
	const { children, className, style, variant = 'section' } = props

	return (
		<div className={clsx(cl.root, cl[`root_${variant}`], className)} style={style}>
			{children}
		</div>
	)
}
